import { FrequencyType } from 'src/types/common';

import { User } from './user';
import { Department } from './template';
import { httpClient, QueryParams } from './httpClient';

export enum MetricType {
  KPI = 'KPI',
  KPI_SUM = 'KPI_SUM',
}

export enum DashboardSettingRateType {
  AchievementRate = 'AchievementRate',
  CompletionRate = 'CompletionRate',
}

export interface DashboardSetting {
  type: MetricType;
  span: number;
  subjectId: string;
  frequencyType: FrequencyType;
  name: string;
  formulaType: DashboardSettingRateType;
}

export interface CustomDashboard {
  id: string;
  creator?: User;
  lastUpdater?: User;
  createdAt?: string;
  updatedAt?: string;
  code?: string;
  frequencyType: string;
  departments: Department[];
  name?: string;
  description?: string;
  enabled?: boolean;
  settings: DashboardSetting[];
}

export interface EnabledDashboardQuery {
  departmentId: string;
  frequencyType: FrequencyType;
}

export async function getEnabledDashboard(
  params?: EnabledDashboardQuery
): Promise<CustomDashboard> {
  const queryParams: QueryParams = {};

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams[key] = String(value);
      }
    });
  }

  const response = await httpClient.sendRequest({
    url: 'dashboards/enabled',
    method: 'GET',
    queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
  });
  return response.data;
}
export async function createEnabledDashboard(data: {
  frequencyType: string;
  departments: Department[];
  settings: DashboardSetting[];
}): Promise<CustomDashboard> {
  const response = await httpClient.sendRequest({
    url: 'dashboards',
    method: 'POST',
    data,
  });
  return response.data;
}
export async function updateEnabledDashboard(data: CustomDashboard): Promise<CustomDashboard> {
  const response = await httpClient.sendRequest({
    url: 'dashboards',
    method: 'PUT',
    data,
  });
  return response.data;
}
